module.exports = __webpack_public_path__ + "img/weatherpedia-pwa9.a3a53da4.jpg";